export enum PortBerthingTypes {
  MED_MOOR = 'med_moor',
  ALONG_SIDE = 'along_side',
  BOTH = 'both',
  ANCHOR = 'anchor',
  STERN_ONLY = 'stern_only',
  SIDE_POSSIBLE = 'side_possible',
  // Port-capacity only: a port marked THIRD supports med_moor, along_side and anchor
  // operationally. THIRD itself must never be sent as a port call's plannedBerthingType
  // or as a tariff's berthingType — see relevantBerthingTypesForCapacity().
  THIRD = 'third'
}
